import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { DokumentenverweisService } from '../../api';
import { DokumentenModel } from '../../models/DokumentenModel';

export const loadDocument =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new DokumentenverweisService()
      .getFileDtoBydokumentenverweisId(id)
      .then(response => {
        const dok: DokumentenModel = {
          id: id,
          type: response.data.extension,
          wert: response.data.base64EncodedImage,
        };

        dispatch({
          type: ActionTypes.SET_DOKUMENTENVERWEIS,
          payload: dok,
        });
      });
  };

export const uploadFile = (
  filename: string,
  referenzId: number,
  file: any,
  successHandler?: () => void
) => {
  return async (dispatch: Dispatch<ReduxAction>) => {
    new DokumentenverweisService()
      .uploadFile(filename, referenzId, file)
      .then((response: any) => {
        if (successHandler) successHandler();
      });
  };
};

export const deleteFile = (
  dokumentverweisId: number,
  successHandler?: () => void
) => {
  return (dispatch: Dispatch<ReduxAction>) => {
    new DokumentenverweisService()
      .deleteBydokumentenverweisId(dokumentverweisId)
      .then(() => {
        if (successHandler) successHandler();
      });
  };
};
